import { _ as O } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.join-c1bca812.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { f as A, e as w, a as P, r as H } from "./es.string.replace-f4cc3aea.js";
import { b as I, f as T, j as U, k as M, l as L, r as W, h as k, m as q } from "./export-cdcbfb2b.js";
import { s as K } from "./species-constructor-00346775.js";
import { t as Y } from "./to-string-92a62764.js";
import "./es.string.trim-6e13db75.js";
import { c as _ } from "./index-8b07dec9.js";
import { forwardRef as D } from "react";
import G, { css as S } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as X } from "./getMetrics-953aa4f8.js";
import { jsx as B } from "react/jsx-runtime";
import "./array-method-is-strict-e5a3c878.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./function-apply-4756dee6.js";
import "./classof-21a3574e.js";
import "./string-trim-14e37ad3.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
var y = U, N = I, V = A, J = M, Q = L, Z = W, z = K, tt = P, it = k, C = Y, rt = q, E = H, et = w, at = T, u = et.UNSUPPORTED_Y, ot = 4294967295, nt = Math.min, $ = N([].push), j = N("".slice), st = !at(function() {
  var t = /(?:)/, a = t.exec;
  t.exec = function() {
    return a.apply(this, arguments);
  };
  var o = "ab".split(t);
  return o.length !== 2 || o[0] !== "a" || o[1] !== "b";
}), F = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
"test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
".".split(/()()/).length > 1 || "".split(/.?/).length;
V("split", function(t, a, o) {
  var v = "0".split(void 0, 0).length ? function(l, r) {
    return l === void 0 && r === 0 ? [] : y(a, this, l, r);
  } : a;
  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function(r, e) {
      var i = Z(this), c = Q(r) ? void 0 : rt(r, t);
      return c ? y(c, r, i, e) : y(v, C(i), r, e);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function(l, r) {
      var e = J(this), i = C(l);
      if (!F) {
        var c = o(v, e, i, r, v !== a);
        if (c.done)
          return c.value;
      }
      var f = z(e, RegExp), x = e.unicode, R = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (u ? "g" : "y"), p = new f(u ? "^(?:" + e.source + ")" : e, R), d = r === void 0 ? ot : r >>> 0;
      if (d === 0)
        return [];
      if (i.length === 0)
        return E(p, i) === null ? [i] : [];
      for (var m = 0, n = 0, s = []; n < i.length; ) {
        p.lastIndex = u ? 0 : n;
        var h = E(p, u ? j(i, n) : i), b;
        if (h === null || (b = nt(it(p.lastIndex + (u ? n : 0)), i.length)) === m)
          n = tt(i, n, x);
        else {
          if ($(s, j(i, m, n)), s.length === d)
            return s;
          for (var g = 1; g <= h.length - 1; g++)
            if ($(s, h[g]), s.length === d)
              return s;
          n = m = b;
        }
      }
      return $(s, j(i, m)), s;
    }
  ];
}, F || !st, u);
var lt = ["width", "height", "minHeight", "maxHeight", "ratio", "borderRadius", "objectFit", "objectPosition", "variant", "className", "children"], ct = /* @__PURE__ */ G.div.withConfig({
  displayName: "aspectRatio__StyledAspectRatio",
  componentId: "kjm91g-0"
})(["&.AspectRatio{", ";> *{", ";}}"], function(t) {
  var a = t.theme.components.aspectRatio, o = t.$style;
  return S(a.AspectRatio, o);
}, function(t) {
  var a = t.$immediateChildStyle;
  return S(a);
}), Gt = /* @__PURE__ */ D(function(t, a) {
  var o = t.width, v = o === void 0 ? "100%" : o, l = t.height, r = t.minHeight, e = t.maxHeight, i = t.ratio, c = t.borderRadius, f = t.objectFit, x = f === void 0 ? "contain" : f, R = t.objectPosition, p = t.variant, d = p === void 0 ? "none" : p, m = t.className, n = t.children, s = O(t, lt), h = X({
    label: "AspectRatio"
  }), b = i == null ? void 0 : i.split(/[:/]/).map(function(g) {
    return g.trim();
  }).join("/");
  return /* @__PURE__ */ B(ct, Object.assign({
    ref: a,
    $style: {
      width: v,
      height: l,
      minHeight: r,
      maxHeight: e,
      borderRadius: c,
      aspectRatio: b
    },
    $immediateChildStyle: {
      objectFit: x,
      objectPosition: R
    },
    className: _(["AspectRatio", "AspectRatio--" + d, m])
  }, h, s, {
    children: n
  }));
});
export {
  Gt as AspectRatio
};
